module.exports = __webpack_public_path__ + "img/yun.b5a82aad.png";